module.exports = __webpack_public_path__ + "img/11_15_bg.0843e5f6.png";